"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _graphqlTag = _interopRequireDefault(require("graphql-tag"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  query getInspirationPostsForCampaign(\n    $inspirationCampaignId: String!,\n    $searchTerm: String,\n    $order: SortOrder,\n    $sortBy: String,\n    $createdBy: String,\n    $isPublic: Boolean,\n    ) {\n    getInspirationPostsForCampaign(\n      inspirationCampaignId: $inspirationCampaignId,\n      searchTerm: $searchTerm,\n      order: $order,\n      sortBy: $sortBy,\n      createdBy: $createdBy,\n      isPublic: $isPublic\n    ) {\n      inspirationId\n      assetId\n      thumbnailUrl\n      title\n      description\n      updatedAt\n      status\n      updatedByUser {\n        firstName\n        lastName\n        imageUrl\n      }\n      createdByUser {\n        firstName\n        lastName\n        imageUrl\n      }\n      isFavourited\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var GET_INSPIRATION_POSTS_CAMPAIGN = (0, _graphqlTag.default)(_templateObject());

var getInspirationPostsForCampaign = function getInspirationPostsForCampaign(inspirationCampaignId) {
  return {
    query: GET_INSPIRATION_POSTS_CAMPAIGN,
    module: 'inspirations',
    ignoreCache: true,
    buildVariables: function buildVariables() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          searchTerm = _ref.searchTerm,
          order = _ref.order,
          sortBy = _ref.sortBy,
          createdBy = _ref.createdBy,
          isPublic = _ref.isPublic;

      return {
        inspirationCampaignId: inspirationCampaignId,
        searchTerm: searchTerm,
        order: order,
        sortBy: sortBy,
        createdBy: createdBy,
        isPublic: isPublic
      };
    }
  };
};

var _default = getInspirationPostsForCampaign;
exports.default = _default;